import { Pressable, StyleSheet, Text, View } from 'react-native';

import { colorSemantic, radii, spacing, unisonColors, useAppTheme } from '@/theme';

export type HandoffActivityFilter = 'sms' | 'correspondence';

interface HandoffActivityFilterChipsProps {
  readonly activeFilter: HandoffActivityFilter;
  readonly smsLabel: string;
  readonly correspondenceLabel: string;
  readonly onSelect: (filter: HandoffActivityFilter) => void;
  readonly testID?: string;
}

export const HandoffActivityFilterChips = ({
  activeFilter,
  smsLabel,
  correspondenceLabel,
  onSelect,
  testID = 'handoff-activity-chips',
}: HandoffActivityFilterChipsProps) => {
  const { colors } = useAppTheme();

  const renderChip = (value: HandoffActivityFilter, label: string) => {
    const isActive = activeFilter === value;

    return (
      <Pressable
        accessibilityRole="button"
        accessibilityState={{ selected: isActive }}
        style={[styles.chip, isActive && styles.chipActive]}
        testID={`handoff-activity-chip-${value}`}
        onPress={() => onSelect(value)}>
        <Text
          style={[
            styles.chipLabel,
            { color: isActive ? colors.textNdPrimary : colors.textNdMuted },
          ]}>
          {label}
        </Text>
      </Pressable>
    );
  };

  return (
    <View style={styles.row} testID={testID}>
      {renderChip('sms', smsLabel)}
      {renderChip('correspondence', correspondenceLabel)}
    </View>
  );
};

const styles = StyleSheet.create({
  row: {
    columnGap: spacing[2],
    flexDirection: 'row',
    paddingBottom: spacing[2],
    paddingTop: spacing[3],
  },
  chip: {
    backgroundColor: unisonColors.white,
    borderColor: unisonColors.borderNdBase,
    borderRadius: radii.sm,
    borderWidth: 1,
    paddingHorizontal: spacing[3],
    paddingVertical: spacing[1],
  },
  chipActive: {
    backgroundColor: colorSemantic.colorBgBrandWeak,
    borderColor: colorSemantic.colorBorderBrandBase,
  },
  chipLabel: {
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 20,
  },
});
